export const IN_APP = 'IN_APP';
export const PUBLIC = 'PUBLIC';
export const ADMIN_PREVIEW = 'ADMIN_PREVIEW';